import { useNavigation } from '@app/hooks/useNavigation';
import { useEffect, useRef, useState } from 'react';
import { Layout } from '../Layout/Layout';
import { TaskCard } from '@components/block/TaskCard/TaskCard';
import { ChatV2 } from '@components/block/ChatV2/ChatV2'; // Added import

export function Dashboard() {
  const { navigation, setNavigation } = useNavigation();
  const [isAtBottom, setIsAtBottom] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (navigation.scope !== 'dashboardv2') {
      setNavigation((nav) => void (nav.scope = 'dashboardv2'));
    }
  }, [navigation]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      if (scrollContainer) {
        const isBottom = Math.abs(
          scrollContainer.scrollHeight -
          scrollContainer.scrollTop -
          scrollContainer.clientHeight
        ) < 10;

        setIsAtBottom(isBottom);
      }
    };

    handleScroll();

    // on scroll & resize
    scrollContainer?.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    // cleanup
    return () => {
      scrollContainer?.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  // sample data
  const sampleTasks = [
    {
      title: "Datenschutzerklärung erstellen",
      description: "Erstellen Sie eine Datenschutzerklärung für Ihre Website gemäß DSGVO.",
      lastModified: "15.04.2023",
      status: "Abgeschlossen"
    },
    {
      title: "Cookie-Banner einrichten",
      description: "Implementieren Sie ein DSGVO-konformes Cookie-Banner auf Ihrer Website.",
      lastModified: "22.05.2023",
      status: "In Bearbeitung"
    },
    {
      title: "Auftragsverarbeitungsvertrag",
      description: "Erstellen Sie einen AVV für Ihre Dienstleister.",
      lastModified: "10.06.2023",
      status: "Abgeschlossen"
    }
  ];
  const tasks = Array(8).fill(0).flatMap(() => sampleTasks);

  return (
    <Layout title="">
      <div className="flex flex-col w-full px-0 sm:px-2 lg:w-2/3 xl:w-3/5">
        <div className="flex-shrink-0 inline-block border-b-2 border-primary-root pb-3 w-48 md:w-60 mb-4 sm:mb-6 px-2 sm:px-4 text-center">
          <h3 className="text-primary-400 font-semibold">DSE</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-8 text-sm">
          <div>
            <p className="text-gray-700 mb-2">
              Hier siehst du alle Aufgaben zum Thema Website. Falls nötig, kannst du diese auch erneut bearbeiten oder
              deine bereits gemachten Angaben verändern.
            </p>
          </div>
          <div className="text-right">
            <p className="text-gray-700">
              Aktuell gibt es in diesem Bereich keine weiteren Aufgaben für Dich.
            </p>
          </div>
        </div>

        <div className="relative">
          <div
            ref={scrollContainerRef}
            className="overflow-y-auto lg:max-h-[calc(100vh-500px)] sm:max-h-[calc(100vh-440px)] md:max-h-[calc(100vh-530px)]"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 md:gap-5" 
                 style={{
                   gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))'
                 }}>
              {tasks.map((task, index) => (
                <TaskCard
                  key={index}
                  title={task.title}
                  description={task.description}
                  lastModified={task.lastModified}
                  status={task.status}
                />
              ))}
            </div>
          </div>
          {/* gradient shadow overlay */}
          <div
            className={`absolute bottom-0 left-0 right-0 h-16 sm:h-20 pointer-events-none z-10 transition-opacity duration-300 ${isAtBottom ? 'opacity-0' : 'opacity-100'}`}
            style={{
              background: 'linear-gradient(to top, rgba(245,245,245,1) 0%, rgba(245,245,245,0.8) 40%, rgba(245,245,245,0) 100%)'
            }}
          ></div>
        </div>

        <div className="mt-4 sm:mt-6 md:mt-8">
          <ChatV2 displayMode="inputOnly" />
        </div>
      </div>
    </Layout>
  );
}
